<template>
  <b-nav-item-dropdown
    right
    toggle-class="d-flex align-items-center dropdown-user-link"
    class="dropdown-user"
  >
    <template
      v-if="loggedIn && userData"
      #button-content
    >
      <div class="d-sm-flex d-none user-nav">
        <p class="user-name font-weight-bolder mb-0">
          {{ userData.full_name }}
        </p>
        <span class="user-status">{{ userData.full_name }}</span>
      </div>
      <b-avatar
        size="40"
        :src="userData.avatar"
        :text="avatarText(userData.full_name)"
        variant="light-primary"
        :badge="hasNewUpdate"
        class="badge-minimal"
        badge-variant="success"
      >
        <feather-icon
          v-if="defaultAvatar(userData.avatar) === ''"
          icon="UserIcon"
          size="22"
        />
      </b-avatar>
    </template>
    <slot name="dropdownItemFirst" />
    <b-dropdown-item
      :to="{ name: 'account-setting' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="UserIcon"
        class="mr-50"
      />
      <span>{{ $t('Profile') }}</span>
    </b-dropdown-item>
    <!-- <b-dropdown-item
      :to="{ name: 'pages-profile'}"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="UserIcon"
        class="mr-50"
      />
      <span>{{ $t('Profile') }}</span>
    </b-dropdown-item> -->
    <!-- <b-dropdown-item
      :to="{ name: 'apps-email' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="MailIcon"
        class="mr-50"
      />
      <span>{{ $t('Inbox') }}</span>
    </b-dropdown-item> -->
    <!-- <b-dropdown-item
      :to="{ name: 'apps-todo' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="CheckSquareIcon"
        class="mr-50"
      />
      <span>Task</span>
    </b-dropdown-item> -->
    <!-- <b-dropdown-item
      :to="{ name: 'apps-chat' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="MessageSquareIcon"
        class="mr-50"
      />
      <span>Chat</span>
    </b-dropdown-item> -->
    <!-- <b-dropdown-divider /> -->
    <!-- <b-dropdown-item
      :to="{ name: 'pages-account-setting' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="SettingsIcon"
        class="mr-50"
      />
      <span>{{ $t('Settings') }}</span>
    </b-dropdown-item> -->
    <!-- <b-dropdown-item
      :to="{ name: 'pages-pricing' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="CreditCardIcon"
        class="mr-50"
      />
      <span>Pricing</span>
    </b-dropdown-item> -->
    <!-- <b-dropdown-item
      :to="{ name: 'pages-faq' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="HelpCircleIcon"
        class="mr-50"
      />
      <span>FAQ</span>
    </b-dropdown-item> -->
    <b-dropdown-divider />
    <b-dropdown-item
      link-class="d-flex align-items-center"
      @click="logout"
    >
      <feather-icon
        size="16"
        icon="LogOutIcon"
        class="mr-50"
      />
      <span>{{ $t('Logout') }}</span>
    </b-dropdown-item>
    <slot name="dropdownItemLast" />
  </b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar,
} from 'bootstrap-vue'
import { defaultAvatar } from '@/@core/utils/utils'
import { avatarText } from '@core/utils/filter'
import { mapState } from 'vuex'
import useJwt from '@/auth/jwt/useJwt'

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
  },
  data() {
    return {
      avatarText,
      hasNewUpdate: false,
      defaultAvatar,
    }
  },
  computed: {
    // mix the getters into computed with object spread operator
    ...mapState({
      loggedIn: state => state.auth.loggedIn,
      userData: state => {
        state.auth.user.avatar = `${state.auth.user.avatar}?t=${(new Date()).getTime()}`;
        return state.auth.user
      },
    }),
  },
  methods: {
    logout() {
      useJwt
        .logout()
        .then(response => {
          if (response.status === 200) {
            // clear auth data
            useJwt.clearAuthData();

            // Redirect to login page
            this.$router.push({ name: 'auth-login' })
          }
        })
    },
  },
}
</script>
